<template>
  <section>
    <ValidationObserver>
      <a-card :title="$t('Documents')">
        <h4>
          {{ $t("Documents Description") }}
        </h4>
        <p></p>
        <a-row :gutter="16">
          <a-col :span="24">
            <h5>{{ $t("Certificate of Incorporation") }}</h5>
            <upload-files
              :size="uiSize"
              :file.sync="fileList4Incorporation"
              fileType="institution_doc_certification"
            ></upload-files>
          </a-col>
        </a-row>
        <br />
        <a-row :gutter="16">
          <a-col :span="24">
            <h5>{{ $t("Partnership Agreement") }}</h5>
            <upload-files
              :size="uiSize"
              :file.sync="fileList4Agreement"
              fileType="institution_doc_agreement"
            ></upload-files>
          </a-col>
        </a-row>
        <br />
        <a-row :gutter="16">
          <a-col :span="24">
            <h4>{{ $t("Organizational Chart") }}</h4>
            <h5>
              {{ $t("organizational_chart_subtitle") }}
            </h5>
            <div class="sampleList">
              <div
                class="sampleItem"
                v-for="(sample, index) in sampleList"
                :key="index"
              >
                <a :href="sample.href" target="_blank">{{
                  `${$t("Sample")} ${index + 1}`
                }}</a>
              </div>
            </div>
            <upload-files
              :size="uiSize"
              :file.sync="fileList4Organizational"
              fileType="institution_doc_organization"
            ></upload-files>
          </a-col>
        </a-row>
        <br />
        <a-row :gutter="16">
          <a-col :span="24">
            <h4>{{ $t("Proof of Address") }}</h4>
            <h5>
              {{ $t("proff_of_address_subtitle") }}
            </h5>
            <upload-files
              :size="uiSize"
              :file.sync="fileList4Address"
              fileType="institution_doc_residence"
            ></upload-files>
          </a-col>
        </a-row>
        <br />
        <a-row :gutter="16">
          <a-col :span="24">
            <h4>{{ $t("Regulated Financial Institution") }}</h4>
            <a-select
              class="select_y_n"
              :size="$store.state.clientInfo.uiSize"
              :getPopupContainer="() => $root.$el"
              v-model="regulated"
            >
              <a-icon slot="suffixIcon" type="caret-up" theme="filled" />
              <a-select-option value="No">{{ $t("No") }}</a-select-option>
              <a-select-option value="Yes">{{ $t("Yes") }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <br />
        <a-row :gutter="16">
          <a-col :span="24">
            <h4>{{ $t("BSA/AML Policy") }}</h4>
            <h5>
              {{ $t("BSA/AML_policy_subtitle") }}
            </h5>
            <upload-files
              :size="uiSize"
              :file.sync="fileList4Policy"
              fileType="institution_doc_policy"
            ></upload-files>
          </a-col>
        </a-row>
        <br />
      </a-card>
      <btm-step-nav-institution
        :passed="fileValid"
        :loading="isLoading"
        @submitForm="submitForm"
      ></btm-step-nav-institution>
    </ValidationObserver>
  </section>
</template>

<script>
import { mapState } from "vuex";
import {
  Card,
  Form,
  Button,
  Input,
  Row,
  Col,
  Upload,
  Icon,
  Select
} from "ant-design-vue";
import BtmStepNavInstitution from "@/components/BtmStepNavInstitution";
import UploadFiles from "@/components/UploadFiles";
import { getDocumentsInfo, submitDocumentsInfo } from "@/api/kyc";
import { displayErrors } from "@/utils";

const PREFIX_ORIGIN = "__origin-";

export default {
  name: "Documents",
  data() {
    return {
      isLoading: false,
      fileList4Incorporation: [],
      fileList4Agreement: [],
      fileList4Organizational: [],
      fileList4Address: [],
      regulated: "No",
      fileList4Policy: [],
      sampleList: [
        {
          href: require("@/assets/img/organizational/sample-1.png")
        },
        {
          href: require("@/assets/img/organizational/sample-2.png")
        }
      ]
    };
  },
  components: {
    [Card.name]: Card,
    [Card.Meta.name]: Card.Meta,
    [Button.name]: Button,
    [Input.name]: Input,
    [Form.name]: Form,
    [Form.Item.name]: Form.Item,
    [Row.name]: Row,
    [Col.name]: Col,
    [Upload.name]: Upload,
    [Icon.name]: Icon,
    [Select.name]: Select,
    [Select.Option.name]: Select.Option,
    BtmStepNavInstitution,
    UploadFiles
  },
  computed: {
    ...mapState({
      uiSize: state => state.clientInfo.uiSize
    }),
    fileValid() {
      // 有一个文件没有上传就为false
      return this.fileList4Incorporation.length === 0 ||
        this.fileList4Agreement.length === 0 ||
        this.fileList4Organizational.length === 0 ||
        this.fileList4Address.length === 0 ||
        (this.regulated === "Yes" && this.fileList4Policy.length === 0)
        ? false
        : true;
    }
  },
  methods: {
    setupFileList(type, name) {
      if (!name) return;

      this[`fileList4${type}`] = [
        { uid: `${PREFIX_ORIGIN}${Date.now()}`, name, status: "done" }
      ];
    },
    appendFileList(formData, type, name) {
      this[`fileList4${type}`]
        .filter(({ uid }) => {
          if (uid) {
            return !uid.startsWith(PREFIX_ORIGIN);
          } else {
            return true;
          }
        })
        .forEach(({ file_path }) => {
          formData.append(name, file_path);
        });
    },
    async submitForm(callBack) {
      const formData = new FormData();
      formData.append("regulated_financial_institution", this.regulated);

      this.appendFileList(formData, "Incorporation", "certification_file");
      this.appendFileList(formData, "Agreement", "agreement_file");
      this.appendFileList(formData, "Organizational", "organization_file");
      this.appendFileList(formData, "Address", "address_file");
      this.appendFileList(formData, "Policy", "policy_file");

      try {
        this.isLoading = true;
        await submitDocumentsInfo(formData);
        callBack(true);
        this.isLoading = false;
      } catch (err) {
        callBack(false);
        displayErrors(err);
        this.isLoading = false;
      }
    },
    async fetchData() {
      try {
        const data = await getDocumentsInfo();
        this.regulated = data.regulated_financial_institution || "No";

        this.setupFileList(
          "Incorporation",
          data.certification_file_original_name
        );
        this.setupFileList("Agreement", data.agreement_file_original_name);
        this.setupFileList(
          "Organizational",
          data.organization_file_original_name
        );
        this.setupFileList("Address", data.address_file_original_name);
        this.setupFileList("Policy", data.policy_file_original_name);

        this.immediate = true;
      } catch (err) {
        displayErrors(err);
      }
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style lang="scss" scoped>
.sampleList {
  display: flex;
  align-items: center;
  .sampleItem {
    margin-right: 2rem;
    margin-bottom: 1rem;
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
